import './index.less';
import Ad from './Ad';

Ad.install = function(Vue) {
  Vue.component(Ad.name, Ad);
};

export default Ad;
